<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><g clip-path="url(#clip0_748_46440)" stroke="transparent"><g clip-path="url(#clip1_748_46440)"><path d="M3.125 0h10l5 5v13.75c0 .69-.56 1.25-1.25 1.25H3.125c-.69 0-1.25-.56-1.25-1.25V1.25c0-.69.56-1.25 1.25-1.25Z" fill="#F76560"></path><path d="M4.53 13.982h-.604a.225.225 0 0 1-.226-.244V9.226A.226.226 0 0 1 3.926 9h1.317c1.35-.018 2.026.495 2.026 1.54-.036.974-.612 1.488-1.728 1.542h-.785v1.656a.226.226 0 0 1-.226.244Zm.226-4.165v1.408c.054 0 .162.009.325.027.717.072 1.07-.171 1.051-.73 0-.488-.347-.723-1.051-.705a.74.74 0 0 1-.325 0Zm3.262 3.921V9.226A.226.226 0 0 1 8.244 9h1.475c1.66 0 2.495.858 2.518 2.514C12.26 13.17 11.38 14 9.719 14H8.244a.226.226 0 0 1-.226-.262ZM9.07 9.8v3.33h.569c.993.036 1.48-.514 1.462-1.651-.018-1.137-.505-1.697-1.462-1.679h-.569Zm4.878 4.183h-.604a.226.226 0 0 1-.226-.226v-4.53A.226.226 0 0 1 13.342 9h2.766a.226.226 0 0 1 .226.226v.384a.226.226 0 0 1-.226.225h-1.935v1.196h1.805a.226.226 0 0 1 .225.226v.388a.226.226 0 0 1-.225.225h-1.805v1.868a.226.226 0 0 1-.226.244Z" fill="#fff"></path><path d="m13.125 0 5 5h-3.75c-.69 0-1.25-.56-1.25-1.25V0Z" fill="#FBACA3"></path></g></g><defs><clipPath id="clip0_748_46440"><path fill="#fff" d="M0 0h20v20H0z"></path></clipPath><clipPath id="clip1_748_46440"><path fill="#fff" d="M0 0h20v20H0z"></path></clipPath></defs></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconFilePdfColor',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-file-pdf-color`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
